import React from "react";
import NavBar from "../components/NavBar";

const TrainsEscapePrivacyPage = ({ language, onLanguageChange, t }) => {
  const collectionItems = t("trainsPrivacy.collection.items") || [];
  const thirdPartyProviders = t("trainsPrivacy.thirdParty.providers") || [];

  return (
    <div
      className="page foody-page trains-page support-page"
      id="trains-privacy-top"
    >
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[
          { href: "/apps/trainsescape", label: t("trainsPrivacy.nav.back") },
          {
            href: "/apps/trainsescape/static/support",
            label: t("trainsPrivacy.nav.support"),
          },
        ]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("trainsPrivacy.badge")}</span>
            <h1>{t("trainsPrivacy.hero.title")}</h1>
            <p>{t("trainsPrivacy.hero.desc")}</p>
            <p className="support-muted">
              {t("trainsPrivacy.hero.effectiveDate")}
            </p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("trainsPrivacy.collection.title")}</h3>
              <p>{t("trainsPrivacy.collection.desc")}</p>
              <ul className="support-list">
                {collectionItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <p className="support-muted">
                {t("trainsPrivacy.collection.noLocation")}
              </p>
              <p className="support-muted">
                {t("trainsPrivacy.collection.noAi")}
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.personal.title")}</h3>
              <p>{t("trainsPrivacy.personal.p1")}</p>
              <p>{t("trainsPrivacy.personal.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.thirdParty.title")}</h3>
              <p>{t("trainsPrivacy.thirdParty.p1")}</p>
              <p>{t("trainsPrivacy.thirdParty.p2")}</p>
              <ul className="support-list">
                {thirdPartyProviders.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {provider.name}
                    </a>
                  </li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.disclosure.title")}</h3>
              <p>{t("trainsPrivacy.disclosure.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.optOut.title")}</h3>
              <p>{t("trainsPrivacy.optOut.desc")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.retention.title")}</h3>
              <p>{t("trainsPrivacy.retention.desc")}</p>
              <p>
                {t("trainsPrivacy.retention.contactLabel")}
                <br />
                <a href="mailto:support-trainsescape@wodaslabs.com">
                  support-trainsescape@wodaslabs.com
                </a>
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.children.title")}</h3>
              <p>{t("trainsPrivacy.children.p1")}</p>
              <p>{t("trainsPrivacy.children.p2")}</p>
            </article>

            <article className="foody-card">
              <h3>{t("trainsPrivacy.security.title")}</h3>
              <p>{t("trainsPrivacy.security.p1")}</p>
              <p>{t("trainsPrivacy.security.p2")}</p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("trainsPrivacy.contact.title")}</h2>
            <p>
              {t("trainsPrivacy.contact.desc")}
              <br />
              <a href="mailto:support-trainsescape@wodaslabs.com">
                support-trainsescape@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a className="btn primary" href="/apps/trainsescape/static/support">
              {t("trainsPrivacy.contact.cta")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TrainsEscapePrivacyPage;
